import React from 'react'
import PropTypes from 'prop-types'
import RenderComponentProto from '../../render-component-proto'

import FieldsFactory from "../../../../fields3/fields-factory"
import {FieldType} from "../../../../fields3/field-type"
import FieldPicker from "../../../../fields3/render/picker"

export default class ColorComponentProto extends RenderComponentProto {

    static propTypes = {
        id          : PropTypes.string.isRequired,
        renderMode  : PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value       : PropTypes.any,
        canEdit     : PropTypes.bool,

        onChange    : PropTypes.func,
    }

    static defaultProps = {
        canEdit     : false,
    }

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value && this.state.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            })
        }
    }

    render() {
        const classes = Classes('gd-field-color', this.props.renderMode, {
            'disabled': !this.props.canEdit,
        });

        const field3 = FieldsFactory.get({
            fieldId : 'color',
            label   : 'Color',
            type    : FieldType.COLOR
        })

        return (
            <div className={classes}>
                <div className="field-holder">
                    <FieldPicker field      = {field3}
                                 model      = {{color: this.state.value}}
                                 onChange   = {this.props.onChange}/>
                </div>
            </div>
        );
    }
}
